import ObjectPool from "../../Generic/Pools/ObjectPool";
import { PromotionManager } from "./PromotionManager";

export class PromotionCache {
    protected manager: PromotionManager;
    protected version: number;
    protected criteriaCache: Record<string, "ignore" | "include" | "exclude">;
    protected promotionCache: {};
    protected criteriaValidCache: Record<string, Array<boolean>>;

    constructor(manager: PromotionManager, version: number) {
        this.manager = manager;
        this.version = version;
        this.criteriaCache = ObjectPool.Get() as {};
        this.promotionCache = ObjectPool.Get() as {};
        this.criteriaValidCache = ObjectPool.Get();
    }

    /**
     * Get the key for the criteria cache
     */
    protected getCriteriaCacheName(uuid: string, criteriaId: number, promotionId: string): string {
        return promotionId + criteriaId + uuid;
    }

    /**
     * Check whether an item is in a criteria via the cache
     */
    public checkCriteriaCache(
        uuid: string,
        criteriaId: number,
        promotionId: string
    ): false | "ignore" | "include" | "exclude" {
        // Get the criteria cache name
        const name = this.getCriteriaCacheName(uuid, criteriaId, promotionId);

        if(typeof this.criteriaCache[name] !== "undefined") {
            return this.criteriaCache[name];
        }

        return false;
    }

    /**
     * Check if the provided criteria is valid for the current promotion calculation
     */
    public isCriteriaValid(promotion: string, criteriaIndex: number): boolean {
        return this.criteriaValidCache[promotion]?.[criteriaIndex] ?? false;
    }

    /**
     * Clear the criteria validity cache
     */
    public clearCriteriaValidity(): void {
        ObjectPool.Release(this.criteriaValidCache);
        this.criteriaValidCache = ObjectPool.Get();
    }

    /**
     * Set which criteria are valid in the cache
     */
    public setCriteriaValid(promotion: string, criteria: Array<boolean>): void {
        this.criteriaValidCache[promotion] = criteria;
    }
}
